import { useSelector } from 'react-redux';
import { StoreState } from '../store';

export function useUser() {
  return useSelector((state: StoreState) => {
    return state.user.id ? state.user : null;
  });
}
